export enum ErrorTranslationKey {
    FAILED_TO_LOAD_DATA = "error.failedToLoadData",
    FAILED_TO_SAVE_DATA = "error.failedToSaveData",
    FAILED_TO_REMOVE_DATA = "error.failedToRemoveData",
    UNEXPECTED_ERROR_OCCURRED = "error.unexpectedErrorOccurred",
    FAILED_TO_ADD_DUPLICATE_ATTRIBUTE = "error.failedToAddDuplicateAttribute",
    NOT_ALLOWED_ATTRIBUTE_NAME = "error.notAllowedAttributeName",
}